import { useContext } from 'react';
import 'bulma/css/bulma.min.css';

import { appConfiguration } from '../appConfiguration.ts';
import { BeamlineContext } from '../beamlineProvider.tsx';


const BeamlineHeader: React.FC = () => {

  const beamlineContext = useContext(BeamlineContext);

  return (
    <div className="block do-not-print">
      <nav className="level">
        <div className="level-item has-text-centered">
          <img
            src={`${appConfiguration.config.baseUrl}/static/alt_spectrum_logo-dark.png`}
            alt="The ALS Logo"
            style={{height: "2.3em", marginRight: "1em"}}
          />
          <h1 className="title">{beamlineContext.beamline!.name} Sample {beamlineContext.setNounCapitalized} Tracker</h1>
        </div>
      </nav>

    </div>
  )
}

export default BeamlineHeader
